import React, { FC, useEffect, useState } from 'react'
import styles from "../../assets/styles/layout.module.css"
import { AppStoreIcon, AvtarIcon, CartIcon, CategoryIcon, CrossIcon, Dropdown2Icon, LogoutIcon, NavToggleIcon, PhoneIcon, PlayStoreIcon, SearchIcon, UploadIcon } from '../../utils/functions/Icons'
import LogoIcon from "../../assets/images/layout/header/logo.png"
import { Accordion, AccordionDetails, AccordionSummary, Input, InputAdornment } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import LogoutModal from '../common/LogoutModal'
import { useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../utils/store'
import { myAccountLists } from '../../utils/functions/CustomData'
import { useDispatch } from 'react-redux'
import { setTabValue } from '../../utils/store/myaccount/MyAccountSlice'
import { handleOpenLogoutModal } from '../../utils/store/auth/AuthSlice'
import { useLazyGetAiSearchDataQuery, useLazyGetSearchDataQuery } from '../../utils/store/common/commonApi'
import { slugify } from '../../utils/functions/functions'
import Image from '../common/Image'

interface props {
    primaryMenuData: PrimaryMenuCategory[] | undefined;
    isLoading: boolean
}

const MobileHeader: FC<props> = ({ primaryMenuData, isLoading }) => {
    const [searchResultShow, setSearchResultShow] = useState(false)
    const [expanded, setExpanded] = useState<string | false>(false);
    const [expandedChild, setExpandedChild] = useState<string | false>(false);
    const [showSidebar, setShowSidebar] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [searchMode, setSearchMode] = useState<'medicine' | 'symptom'>('medicine');
    const [handleSearchData, { data: searchDataList, isLoading: searchLoading, isFetching: searchFetching }] = useLazyGetSearchDataQuery();
    const [handleAISearchData, { data: searchAIDataList, isLoading: AiLoading, isFetching: AIFetching }] = useLazyGetAiSearchDataQuery();
    const cartCount = useSelector((state: RootState) => state.cart.cartData.totalItem);
    const { userLogin, authData } = useSelector((state: RootState) => state.auth)
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();

    const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };
    const handleChildChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpandedChild(isExpanded ? panel : false);
    };
    const closeSidebar = () => {
        setShowSidebar(false)
    }
    const openSidebar = () => {
        setShowSidebar(true)
    }

    const handleSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value)
        if (e.target.value) {
            setSearchResultShow(true)
        }
        else {
            setSearchResultShow(false)
        }
    }

    useEffect(() => {
        if (searchResultShow) {
            if (searchValue) {
                const cleanFunction = setTimeout(() => {
                    if (searchMode === "symptom") {
                        handleAISearchData(searchValue?.toLowerCase());
                    } else {
                        handleSearchData(searchValue);
                    }
                }, 1000)
                return () => clearInterval(cleanFunction)
            }
            else {
                if (searchMode === "symptom") {
                    handleAISearchData("");
                } else {
                    handleSearchData("");
                }
            }
        }
    }, [searchValue, searchMode, handleAISearchData, handleSearchData]);

    const handleSearchClick = (link: string, id: number) => {
        setSearchResultShow(false)
        setSearchValue("")
        navigate(`${link}?${new URLSearchParams({ q: `${id}` })}`, { state: id })
    }

    return (
        <div className={`${styles.headerMain} ${styles.headerMainMobile}`}>
            <div className={styles.topbarMainMobile}>
                <div className="container">
                    <div className={styles.topbarMobile}>
                        <div className={styles.topbarLeftMobile}>
                            <h3>Get medicines on <a href='https://api.whatsapp.com/send/?phone=919625996301&text&type=phone_number&app_absent=0' target='_blank' rel="noreferrer">Whatsapp !</a></h3>
                        </div>
                        <div className={styles.topbarRightMobile}>
                            <a href='tel:+919625996301' className={styles.rightContentMain} rel='noreferrer'>
                                <PhoneIcon color='white' />
                                <span>+919625996301</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.navbarMainMobile}>
                <div className="container">
                    <div className={styles.navbarMainMobileSec}>
                        <div className={styles.mobileToggleNav}>
                            <NavToggleIcon onClick={openSidebar} />
                        </div>
                        <div className={styles.logo} onClick={() => navigate('/')}>
                            <Image src={LogoIcon} alt="mchemist logo" />
                        </div>
                        <div className={`${styles.offersMain} relative`} onClick={() => navigate('/cart')}>
                            <CartIcon />
                            <div className={styles.cartCount}>
                                <span>{cartCount || 0}</span>
                            </div>
                        </div>
                    </div>
                    {
                        showSidebar &&
                        <div className={`${styles.mobileRightSidebarNav}`}>
                            <div className={styles.sidebarBox}>
                                <div className={styles.topSec}>
                                    <div className={styles.closeBtn}>
                                        <CrossIcon onClick={closeSidebar} />
                                    </div>
                                    {
                                        userLogin ?
                                            <div className={styles.profileSec}>
                                                <div className={styles.profileIcon}>
                                                    <AvtarIcon color='#54A276' />
                                                </div>
                                                {
                                                    authData?.patient_name &&
                                                    <div className={styles.profileTitle}>
                                                        <h3>Hello,</h3>
                                                        <h3>{authData?.patient_name}</h3>
                                                    </div>
                                                }
                                            </div>
                                            :
                                            <div className={`${styles.loginAndSignupBtn} mt-6`}>
                                                <Link to={'/login'} onClick={() => closeSidebar()}>Login</Link>
                                                <span>|</span>
                                                <Link to={'/signup'} onClick={() => closeSidebar()}>Sign up</Link>
                                            </div>
                                    }
                                    <div className={styles.uploadPrescriptionBtn}>
                                        <button onClick={() => {
                                            closeSidebar();
                                            navigate('/prescription')
                                        }}><span><UploadIcon /> </span> Upload prescription</button>
                                    </div>
                                </div>
                                <div className={styles.categoryNavSection}>
                                    <ul className={styles.CategoryNavItem}>
                                        <li>
                                            <Accordion
                                                className='customAccordion categoryAccordion'
                                                expanded={expanded === `panel1`}
                                                onChange={handleChange(`panel1`)}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<Dropdown2Icon />}
                                                    aria-controls="panel1-content"
                                                    id="panel1-header"
                                                    className='AccordionSummary'
                                                >
                                                    <div className={styles.mobileCategoryHead}>
                                                        <div className={styles.categoryHeadLeft}>
                                                            <CategoryIcon />
                                                            <h4>All categories</h4>
                                                        </div>
                                                    </div>
                                                </AccordionSummary>
                                                <AccordionDetails className='AccordionDetails'>
                                                    <ul className={`${styles.mobileCategoryListMain}`}>
                                                        {
                                                            primaryMenuData?.map((item, index) => {
                                                                return (
                                                                    <React.Fragment key={index}>
                                                                        {
                                                                            item?.medicine_child_categories?.length > 0 ?
                                                                                <Accordion
                                                                                    className='customAccordion categoryAccordion childAccordian'
                                                                                    expanded={expandedChild === `panelchild${index}`}
                                                                                    onChange={handleChildChange(`panelchild${index}`)}
                                                                                >
                                                                                    <AccordionSummary
                                                                                        expandIcon={<Dropdown2Icon />}
                                                                                        aria-controls="ppanelchild"
                                                                                        id="panelchild"
                                                                                        className='AccordionSummary'
                                                                                    >
                                                                                        <div className={styles.mobileCategoryHead}>
                                                                                            <div className={styles.categoryHeadLeft}>
                                                                                                <Link to={item?.cat_url} onClick={(e) => {
                                                                                                    e.stopPropagation();
                                                                                                    closeSidebar()
                                                                                                }}>{item?.medicine_category}</Link>
                                                                                            </div>
                                                                                        </div>
                                                                                    </AccordionSummary>
                                                                                    <AccordionDetails className='AccordionDetails'>
                                                                                        <ul className={`${styles.mobileCategoryListMain} px-0 ml-1`}>
                                                                                            {
                                                                                                item?.medicine_child_categories?.map((childItem, childIndex) => {
                                                                                                    return (
                                                                                                        <li key={childIndex}>
                                                                                                            <Link to={childItem?.cat_url} className={styles.categoryChildItemLink} onClick={() => closeSidebar()}>
                                                                                                                {childItem?.child_name}
                                                                                                            </Link>
                                                                                                        </li>
                                                                                                    )
                                                                                                })
                                                                                            }
                                                                                        </ul>
                                                                                    </AccordionDetails>

                                                                                </Accordion>
                                                                                :
                                                                                <li className={styles.withoutChildLink}><Link to={item?.cat_url} onClick={() => closeSidebar()}>{item?.medicine_category}</Link></li>
                                                                        }
                                                                    </React.Fragment>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                </AccordionDetails>
                                            </Accordion>
                                        </li>
                                        {userLogin &&
                                            myAccountLists?.map((item, index) => {
                                                return (
                                                    <li className={styles.SidebarItemsList} key={index} onClick={() => {
                                                        closeSidebar();
                                                        dispatch(setTabValue(item?.tab ? item?.tab : 0))
                                                    }}>
                                                        <Link to={item?.link}>
                                                            <span>{item?.icon}</span>
                                                            <span>{item?.title}</span>
                                                        </Link>
                                                    </li>
                                                )
                                            })
                                        }
                                        <li className={styles.mobileSidebarDownloadApp}>
                                            <PlayStoreIcon />
                                            <AppStoreIcon />
                                        </li>

                                    </ul>
                                </div>
                                {
                                    userLogin &&
                                    <div className={styles.mobileSidebarLogoutSec}>
                                        <div className={styles.mobileSidebarLogout} onClick={() => dispatch(handleOpenLogoutModal())}>
                                            <LogoutIcon />
                                            <h3>Log out</h3>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div className={styles.searchAndAddressSectionMobileMain}>
                <div className={styles.searchAndAddressSection}>
                    <div className={styles.searchAndAddressMain}>
                        <div className={styles.toggleSwitchContainer}>
                            <div className={styles.toggleSwitch}>
                                <div
                                    className={`${styles.switchThumb} ${searchMode === 'symptom' ? styles.thumbRight : ''}`}
                                />

                                <button
                                    className={`${styles.switchBtn} ${searchMode === 'medicine' ? styles.activeBtn : ''}`}
                                    onClick={() => {
                                        setSearchValue("");
                                        setSearchMode('medicine')
                                    }}
                                >
                                    {
                                        searchLoading || searchFetching ? "Loading..." : "Medicine"
                                    }
                                </button>
                                <button
                                    className={`${styles.switchBtn} ${searchMode === 'symptom' ? styles.activeBtn : ''}`}
                                    onClick={() => {
                                        setSearchValue("");
                                        setSearchMode('symptom')
                                    }}
                                >
                                    {AIFetching || AiLoading ? "Loading..." : "Symptoms"}
                                </button>
                            </div>
                        </div>

                        <div className={styles.searchInput}>
                            <Input
                                name='searchValue'
                                placeholder={searchMode === 'symptom'
                                    ? 'Enter symptoms like headache, cold, etc.'
                                    : 'Search by medicine name like Dolo 650, Crocin...'}
                                className={`headerSearchInput mobileHeaderSearch ${styles.headerSearchNew}`}
                                value={searchValue}
                                onChange={handleSearchValue}
                                endAdornment={<InputAdornment position="end">{searchValue ==="" ? <SearchIcon /> : <CrossIcon color='#B2B2B2' className='cursor-pointer' onClick={() => {
                                    setSearchValue("");

                                }} />}</InputAdornment>}
                            />
                        </div>
                    </div>
                    {
                        searchMode === "symptom" ?
                            <>
                                {
                                    searchAIDataList && searchResultShow &&
                                    <div className={`${styles.searchResultBox} ${styles.AISearchResultBox}`}>
                                        {searchAIDataList?.summary && (
                                            <div className={styles.searchSummaryBox}>
                                                <h4>Summary</h4>
                                                <p>{searchAIDataList.summary}</p>
                                            </div>
                                        )}
                                        {
                                            searchAIDataList?.recommendations?.length > 0 && (
                                                <div className={styles.searchRecommendationBox}>
                                                    <h4>Recommended Medicines</h4>
                                                    <ul className={styles.searchListMain}>
                                                        {
                                                            searchAIDataList?.recommendations?.map((data, index) => {
                                                                const link = `/detail/${slugify(data?.medicine_name)}-otc${data?.id}`
                                                                return (
                                                                    <li
                                                                        className={styles.searchList}
                                                                        key={index}
                                                                        onClick={() => handleSearchClick(link, Number(data?.id))}
                                                                    >
                                                                        {data?.medicine_name}
                                                                    </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                </div>
                                            )
                                        }
                                    </div>
                                }
                            </>
                            :
                            <>
                                {
                                    searchDataList && searchDataList?.length > 0 && searchResultShow &&
                                    <div className={`${styles.searchResultBox} ${styles.AISearchResultBox}`}>
                                        <ul className={styles.searchListMain}>
                                            {
                                                searchDataList?.map((data: any, index) => {
                                                    return (
                                                        <li
                                                            className={styles.searchList}
                                                            key={index}
                                                            onClick={() => handleSearchClick(data?.link, data?.id)}
                                                        >{data?.medicine_name}</li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                }
                            </>
                    }

                </div>
            </div>
            <LogoutModal />
        </div>
    )
}

export default MobileHeader